import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';
import {ShortVoter} from '../../models/ShortVoter';
import { Assessor } from 'src/app/models/Assessor';

@Component({
  selector: 'assessors-change-mail-popup',
  templateUrl: './assessors-change-mail-popup.component.html',
  styleUrls: ['./assessors-change-mail-popup.component.less', '../../shared/common.less']
})
export class AssessorsChangeMailPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() assessor = new Assessor('Sophie Martin', 'sophie.martin@example.com')
  @Input() mails: Array<ShortVoter> = [];
  @Input() isAssessors = false;
  @Input() assessors = []

  // Tableaux séparés pour les noms et emails
  names: string[] = [];
  emails: string[] = [];

  // Validation des emails
  newEmail: string = '';
  confirmEmail: string = '';
  isFormValid: boolean = false;

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {
    this.mails.forEach(voter => {
      const parts = voter.email.split(' - '); 
      
      if (parts.length === 2) {
        const name = parts[0].trim();
        const email = parts[1].trim();
        
        this.names.push(name);
        this.emails.push(email);
      }
    });
  }

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  /**
   * Vérifie si les deux emails sont valides et identiques
   */
  validateForm(): void {
    this.isFormValid = 
      this.isValidEmail(this.newEmail) && 
      this.isValidEmail(this.confirmEmail) && 
      this.newEmail.trim() === this.confirmEmail.trim();
  }

  /**
   * Appelé quand l'utilisateur modifie le nouvel email
   */
  onNewEmailChange(): void {
    this.validateForm();
  }

  /**
   * Appelé quand l'utilisateur modifie la confirmation email
   */
  onConfirmEmailChange(): void {
    this.validateForm();
  }

}
